import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'components/data-table';
import {RowItemListSearchPeople} from 'modules/reception/datatable/add';
import {header} from "constants/table";
import { Button, Dialog } from '@blueprintjs/core';
import {Input} from 'components/tt-forms/common';
import { Reception } from 'api';

class SearchFullNamePopup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      pageData: {
        number: 0,
        size: 10
      },
      isOpen: false,
      tuKhoa: '',
      soCMNND: '',
      diaChi: '',
      loading: false,
      dataList: []
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  closeDialog() {
    this.props.dispatch({
      type: 'TOGGLE_DIALOG',
      data: {
        name: 'PopupViewAllResult',
        status: false
      }
    });
    this.props.dispatch({
      type: 'DISPLAY_FORM',
      value: false
    });
    this.state.pageData.size = 10;
    this.state.pageData.number = 0;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isViewAll != this.props.isViewAll) {
      this.setState({
        isOpen: nextProps.isViewAll,
        tuKhoa: nextProps.tuKhoa
      }, () => {
        if (nextProps.isViewAll) {
          this.state.pageData.size = 10;
          this.state.pageData.number = 0;
          this.timKiemCongDan();
        }
      });
    }
  }

  timKiemCongDan() {
    this.setState({
      loading: true
    });
    let inputParams = {
      size: this.state.pageData.size,
      page: this.state.pageData.number
    }
    if (this.state.tuKhoa) {
      inputParams.tuKhoa = this.state.tuKhoa;
    }
    if (this.state.soCMNND) {
      inputParams.soCMNND = this.state.soCMNND;
    }
    if (this.state.diaChi) {
      inputParams.diaChi = this.state.diaChi;
    }
    Reception.actions.searchCongDan.request('', inputParams).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          dataList: res.data._embedded.congDans,
          pageData: res.data.page
        });
        this.props.dispatch({
          type: 'DISPLAY_FORM',
          value: false
        });
      } else {
        this.setState({
          dataList: [],
          pageData: {
            number: 0,
            size: 10
          }
        });
      }
      this.setState({
        loading: false
      });
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.timKiemCongDan();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.timKiemCongDan();
  }

  render() {
    return (
      <Dialog className="panel-popup dialog-search-result" inline={ false } isOpen={ this.state.isOpen } onClose={ this.closeDialog.bind(this) } title="Danh sách kết quả tìm kiếm">
        <div className="pt-dialog-body">
          <div id="list-people-search" className="search-name-container">
            <form className="items-form" onSubmit={this.timKiemCongDan.bind(this)} action="javascript:void(0)">
              <div className="rows">

                <Input label="Họ và tên" className="col-w22" maxLength={40} value={this.state.tuKhoa} onChange={this.onChange.bind(this, 'tuKhoa')}/>
                <Input label="Số CMND/ Hộ chiếu" className="col-w22" type="cmnd" maxLength={10} value={this.state.soCMNND} onChange={this.onChange.bind(this, 'soCMNND')}/>
                <Input label="Địa chỉ" className="col-w39" maxLength={70} value={this.state.diaChi} onChange={this.onChange.bind(this, 'diaChi')}/>

                <div className="col-2">
                  <label className="seacrh-people">
                    <Button type="submit" className="btn-search" text="Tìm kiếm"/>
                  </label>
                </div>
              </div>
            </form>

            <DataTable
              header = {header.addReception.searchName}
              dataList = {this.state.dataList}
              hideButtonExport={true}
              pageData= {this.state.pageData}
              parent = {this}
              tableLoading = {this.state.loading}>
              <RowItemListSearchPeople self={this.props.self}/>
            </DataTable>

          </div>
        </div>
      </Dialog>
    );
  }
}

function bindStateToProps(state) {
  return {
    isViewAll: state.formDataTiepCongDan.PopupViewAllResult,
    tuKhoa: state.formDataTiepCongDan.tuKhoa,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon
  };
}

export default connect(bindStateToProps)(SearchFullNamePopup);



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/SearchFullNamePopup.jsx